import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { ColoriFormatiPageConfig } from '../../configuration'
import { styles } from './ColorPicker'
import FormatTicket from './FormatTicket'

const useStyles = makeStyles(styles)

function FormatPicker({ index, handleFade, setVisibleFormat }) {
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <p className={classes.p} >{ColoriFormatiPageConfig.content.tertiary[2]}</p>
            <div className={classes.scroller} >
                {ColoriFormatiPageConfig.formats.map((e, i) => {
                    return <FormatTicket
                        image={e.src}
                        changeFade={handleFade}
                        key={i}
                        setVisibleFormat={setVisibleFormat}
                        active={i === index}
                        index={i}
                        secondaryText={e.secondary}
                        primaryText={e.primary}
                    />
                })}
            </div>
        </div>
    )
}

export default memo(FormatPicker)